import { Claims } from "./modules/auth/models/claims.enums";

export const ApplicationRoutes = Object.freeze({
  Empty: "",
  Root: "/",
  Users: "users",
  MyProfile: "my-profile",
  Dashboard: "dashboard",
  Auth: "auth",
  Login: "login",
  ForgotPassword: "forgot-password",
  Brands: "brands",
  Categories: "categories",
  Colors: "colors",
  Products: "products",
  ProductsRequests: "products-requests",
  Coupons: "coupons",
  Gateway: "gateway",
  Slides: "slides",
  Vendors: "vendors",
  Customers: "customers",
  Notifications: "notifications",
  CustomersCommissions: "customers-commissions",
  Orders: "orders",
  Offers: "offers",
  ProductsSet: "products-set",
  MainScreen: "main-screen",
  Pricing: "pricing",
  Discounts: "discounts",
  Currency: "currency",
  Edit: "edit",
  Create: "create",
  CleanData: "clean-data",
  Countries: "countries",
  CollectionsList: "collections-list",
  pricingDiscounts: "pricing-discounts",
  customerCarts: "customer-carts",
  EmailPromotions: "email-promotions",
  Unsubscribe: "unsubscribe",
  BaseItem: "BaseItem",
  Scraping: "scraping",
  MemberShips: "memberships",
  Shipments: "shipments",
  salesRevenue: "sales-revenue",
  rating: "rating",
  navbarOrdering: "navbar-ordering",
  settings: "settings",
  ShippingCompanies: "shipping-companies",
  QrCode: "qrcode",
  Inventory: "inventory",
  ExportData: "export-data",
  BlackList: "black-list",
});

export const ApplicationMenu = [
  {
    path: ApplicationRoutes.Dashboard,
    label: "Dashboard",
    icon: "fas fa-tachometer-alt",
    claim: -1,
  },
  {
    path: ApplicationRoutes.Users,
    label: "Users",
    icon: "fas fa-users",
    claim: Claims.UsersPage,
  },
  {
    path: ApplicationRoutes.Products,
    label: "Products",
    icon: "fas fa-cubes",
    claim: Claims.GetProducts,
  },
  {
    path: ApplicationRoutes.Coupons,
    label: "Coupons",
    icon: "fas fa-percent",
    claim: Claims.EditCoupons,
  },
  {
    path: ApplicationRoutes.Gateway,
    label: "Gateway",
    icon: "fas fa-credit-card",
    claim: Claims.EditGateway,
  },
  {
    path: ApplicationRoutes.Brands,
    label: "Brands",
    icon: "fas fa-copyright",
    claim: Claims.EditBrands,
  },
  {
    path: ApplicationRoutes.Categories,
    label: "Categories",
    icon: "fas fa-list-ul",
    claim: Claims.EditCategories,
  },
  {
    path: ApplicationRoutes.Notifications,
    label: "Notifications",
    icon: "fas fa-bell",
    claim: Claims.EditNotifications,
  },
  {
    path: ApplicationRoutes.Orders,
    label: "Orders",
    icon: "fas fa-boxes",
    claim: Claims.GetOrders,
  },
  {
    path: ApplicationRoutes.customerCarts,
    label: "Customer Carts",
    icon: "fas fa-shopping-cart",
    claim: Claims.EditCustomerCarts,
  },
  {
    path: ApplicationRoutes.Customers,
    label: "Customers",
    icon: "fas fa-user-friends",
    claim: Claims.EditCustomers,
  },
  // {
  //   path: ApplicationRoutes.CustomersCommissions,
  //   label: "Customers Commissions",
  //   icon: "fas fa-receipt",
  //   claim: Claims.EditCustomerCommissions,
  // },
  // {
  //   path: ApplicationRoutes.Vendors,
  //   label: 'Vendors',
  //   icon: 'fas fa-people-carry',
  //   claim: Claims.EditVendors,
  // },
  {
    path: ApplicationRoutes.BaseItem,
    label: "Base Item",
    icon: "fas fa-sitemap",
    claim: Claims.EditBaseItem,
  },
  // {
  //   path: ApplicationRoutes.MainScreen,
  //   label: 'Main Screen',
  //   icon: 'fas fa-home',
  //   claim: Claims.EditAppMainScreenViewItem,
  // },
  // {
  //   path: ApplicationRoutes.Pricing,
  //   label: 'Pricing',
  //   icon: 'fas fa-money-bill-alt',
  //   claim: Claims.EditPrices,
  // },
  // {
  //   path: ApplicationRoutes.Discounts,
  //   label: 'Discounts',
  //   icon: 'fas fa-tag',
  //   claim: Claims.EditDiscount,
  // },
  {
    path: ApplicationRoutes.Currency,
    label: "Currency Rate",
    icon: "fas fa-dollar-sign",
    claim: Claims.EditCurrencyRate,
  },
  {
    path: ApplicationRoutes.CleanData,
    label: "Clean Data",
    icon: "fas fa-solid fa-soap",
    claim: Claims.CleaningDatabase,
  },
  {
    path: ApplicationRoutes.Countries,
    label: "Countries",
    icon: "fas fa-solid fa-globe",
    claim: Claims.EditCountries,
  },
  {
    path: ApplicationRoutes.CollectionsList,
    label: "Collections",
    icon: "fas fa-layer-group",
    claim: Claims.EditCollections,
  },
  {
    path: ApplicationRoutes.EmailPromotions,
    label: "Email Promotions ",
    icon: "fas fa-envelope",
    claim: Claims.EmailPromotions,
  },
  {
    path: ApplicationRoutes.rating,
    label: "Rating",
    icon: "fas fa-star",
    claim: Claims.EditRating,
  },
  // {
  //   path: ApplicationRoutes.MemberShips,
  //   label: ' Memberships ',
  //   icon: 'fas fa-wallet',
  //   claim: Claims.EditMembership, //need claims
  // },
  {
    path: ApplicationRoutes.Shipments,
    label: " Shipments ",
    icon: "fas fa-truck",
    claim: Claims.EditShipments,
  },
  {
    path: ApplicationRoutes.pricingDiscounts,
    label: "Pricing Discounts",
    icon: "fas fa-coins",
    claim: Claims.PricingDiscounts,
  },
  {
    path: ApplicationRoutes.salesRevenue,
    label: "Sales & Revenue",
    icon: "fas fa-arrow-up",
    claim: -1,
  },
  {
    path: ApplicationRoutes.settings,
    label: "Settings",
    icon: "fas fa-wrench",
    claim: Claims.EditSettings,
  },
  {
    path: ApplicationRoutes.ShippingCompanies,
    label: "Cargo Companies",
    icon: "fas fa-box",
    claim: Claims.EditKargoCompanies,
  },
  {
    path: ApplicationRoutes.ExportData,
    label: "Export Data",
    icon: "fas fa-upload",
    claim: Claims.ExportData,
  },
  {
    path: ApplicationRoutes.BlackList,
    label: "Black List",
    icon: "fas fa-ban",
    claim: Claims.EditBlacklist,
  },
  // {
  //   path: ApplicationRoutes.Inventory,
  //   label: "Inventory",
  //   icon: "fas fa-warehouse",
  //   claim: Claims.EditKargoCompanies, //EditInventory
  // },
  // {
  //   path: ApplicationRoutes.navbarOrdering,
  //   label: 'Navbar Ordering',
  //   icon: 'fas fa-home',
  //   claim: Claims.EditAdmins,
  // },
  {
    path: ApplicationRoutes.Scraping,
    label: "Scraping",
    icon: "fas fa-scroll",
    claim: Claims.Scraping,
  },
];

export const OrderStatusMap = {
  "0": "All",
  "1": "Pending",
  "2": "Accepted",
  "3": "Rejected",
  "4": "Shipped",
  "5": "Delivered",
  "6": "Paid",
  "7": "Confirmed For On Door Payment",
  "8": "Completed",
};

export const tableStateParams = [
  "pageSize",
  "pageNumber",
  "sortField",
  "sortOrder",
  "search",
  "filter",
];
